// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthPage_root__J3pey","backgroundContainer":"AuthPage_backgroundContainer__d8wui","header":"AuthPage_header__3KCA8"};